import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import Button from '../../Button';
import { DocketDotsVerIcon } from '../../SVGIcons/SVGIcons';

export function DraggableColumnItem({ field, index }) {
	return (
		<Draggable
			draggableId={field.id}
			index={index}
			isDragDisabled={field.packageUuid && field.packageUuid !== 'unset' ? true : false}>
			{(provided) => (
				<div
					ref={provided.innerRef}
					{...provided.draggableProps}
					className={`dragableItem${field.packageUuid && field.packageUuid !== 'unset' ? ' disabled' : ''}`}>
					<div {...provided.dragHandleProps}>
						<Button
							size='md'
							style='tertiary-secondary'
							iconLeft={<DocketDotsVerIcon />}
							maxWidth={40}
							minWidth={40}
							disabled={field.packageUuid && field.packageUuid !== 'unset'}
						/>
					</div>
					<div className='textColumn'>
						<h4>{field.itemDesc}</h4>
						<p>{field.note}</p>
					</div>
					{field.packageUuid && field.packageUuid !== 'unset' ? (
						<p style={{ width: '100%' }}>(Already packaged)</p>
					) : (
						<></>
					)}
				</div>
			)}
		</Draggable>
	);
}
